<div class="content-box">
    <div class="picture-box">
        <img src="{{image}}" alt="roboze-photo">
    </div>
    <div class="attention-box">
        <div class="attention-box__icon">
            <nb-icon icon="alert-circle-outline" status="danger"></nb-icon>
        </div>
        <p class="attention-box__text">{{attention}}</p>
    </div>
    <div class="description-box">
        <h3 class="description-box__title">
            {{descriptionTitle}}
        </h3>
        <p class="description-box__text">
            {{descriptionContent}}
        </p>
    </div>
    <div class="buttons-box">
        <button nbButton [size]="'large'" [status]="'control'" [appearance]="'outline'" (click)="cancel()"
                tabindex="-1">
            {{'common.cancel' | translate}}
        </button>
        <button nbButton [status]="'primary'" [size]="'large'" (click)="choosePlan()"
                tabindex="-1">
            {{'common.choose-plan' | translate}}
        </button>
    </div>
</div>